// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

.m-about {
  padding: 0px;
}
@media screen and (max-width: 1200px) {
  .m-about {
    margin-top: 20px;
  }
}
@media screen and (max-width: 1000px) {
  .m-about {
    width: 100%;
  }
}
.m-about.m-image-block {
  padding-left: 15px;
  padding-right: 15px;
}
@media screen and (max-width: 1200px) {
  .m-about.m-image-block {
    margin-top: 0px;
  }
}
@media screen and (max-width: 850px) {
  .m-about.m-image-block {
    margin-top: 20px;
  }
}
.m-about .about-condition {
  width: 100%;
}
.m-about .no-pad-right {
  padding-right: 0px;
}
.m-about h2 {
  font-weight: bold;
  margin: 20px 0 5px 0;
}
.m-about .field_label,
.m-about .field_detail {
  display: table-cell;
  word-wrap: break-word;
  -webkit-table-layout: fixed;
  -moz-table-layout: fixed;
  -ms-table-layout: fixed;
  -o-table-layout: fixed;
  table-layout: fixed;
}
@media screen and (min-width: 769px) and (max-width: 1199px) {
  .m-about .field_label,
  .m-about .field_detail {
    display: block !important;
  }
}
@media screen and (max-width: 599px) {
  .m-about .field_label,
  .m-about .field_detail {
    width: 100% !important;
    display: block !important;
    padding: 0px !important;
  }
}
.m-about .field_label {
  width: 85px;
}
.m-about .field_detail {
  padding-left: 2px;
}
.m-about .list-group .list-group-item {
  display: table;
  width: 100%;
  border: none;
  padding: 3px 0px;
  font-size: 16px;
}
@media screen and (max-width: 599px) {
  .m-about .list-group .list-group-item {
    display: block;
  }
}
.m-about .list-group .list-group-item.col-sm-6 {
  display: block;
}
@media (min-width: 768px) {
  .m-about .list-group .list-group-item.col-sm-6 {
    width: 50%;
  }
}

@media screen and (max-width: 991px) {
  .m-about .no-pad-left {
    padding-right: 0;
  }
}
.edit-image-wrapper {
  position: relative;
}

.person-title {
  max-width: 300px;
  width: 100%;
  margin-right: 15px;
  margin-bottom: 15px;
}
@media screen and (max-width: 1200px) {
  .person-title {
    max-width: 240px;
  }
}
.person-title .img-responsive {
  max-width: 100%;
  width: 100%;
  display: inline-block;
  background: #f2f2f2;
}
.person-title .m-b-sm {
  padding: 5px;
}

.upload_button_holder {
  position: absolute;
  overflow: hidden;
  display: inline-block;
  width: 100%;
  margin-top: -33px;
}
.upload_button_holder .upload_button {
  position: relative;
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  background: rgba(0, 0, 0, 0.4);
  color: #fff;
  padding: 5px 0;
  border-radius: 0;
  width: 100%;
  height: 32px;
  text-decoration: none;
  text-align: center;
  cursor: pointer;
  display: block;
}
.upload_button_holder .cloudinary_fileupload {
  opacity: 0;
  filter: alpha(opacity=0);
  cursor: pointer;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  border: none;
}

.titlename.no-mg-top {
  margin-top: 2px !important;
}

.right-buttons {
  position: absolute;
  right: 10px;
  z-index: 9999;
}
.right-buttons--change1 {
  position: static;
  display: inline-block;
}
.right-buttons--change1 .profile-print-btn {
  padding-right: 10px !important;
}

.user-profile-wrapper a {
  color: #333;
}

.no-margin {
  margin: 0;
}

.m-about p {
  font-size: 14px;
  font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}

.user-profile-wrapper a:hover,
.user-profile-wrapper a:focus,
.user-profile-wrapper a:active {
  color: #333;
  text-decoration: none;
}

.profile-heading {
  margin-left: -20px;
  width: 105%;
}

.client-detail {
  position: relative;
  height: auto;
  margin-top: 30px;
  padding-top: 30px;
  border-top: 1px solid #eee;
}
.client-detail .profile-headers {
  clear: both;
  float: left;
  width: 100%;
  margin: 30px 0;
  font-size: 18px;
  line-height: 1.4;
  font-family: "Conv_museo-500-webfont";
}
.client-detail .profile-headers__inner h2,
.client-detail .profile-headers__inner span {
  margin-top: 0;
}
.client-detail .profile-headers .profile-equation-wrapper {
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.client-detail .profile-headers .profile-equation-wrapper span {
  color: #fff;
  padding: 7px;
}
.client-detail .profile-headers .profile-equation-wrapper .eq-plus {
  color: #6d6e71;
}
.client-detail .profile-headers .profile-equation-result {
  background: #6d6e71;
  padding: 7px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.client-detail .profile-headers .profile-equation-result a {
  color: #fff;
  text-decoration: none;
}
.client-detail .client_description {
  clear: both;
  text-align: justify;
  font-size: 16px;
  margin-bottom: 30px;
  -ms-column-count: 2;
  column-count: 2;
  -ms-column-gap: 20;
  column-gap: 20;
}
.client-detail .client_description span.profile-desc {
  font-weight: 700;
}

.right-label-text .eq-implementer {
  background-color: rgb(245, 67, 89) !important;
}
.right-label-text .eq-clarifier {
  background-color: rgb(0, 173, 208) !important;
}
.right-label-text .eq-ideator {
  background-color: rgb(255, 121, 0) !important;
}

::ng-deep .user-profile-icon-wrapper {
  margin-top: -12px;
  margin-left: 19px;
}
::ng-deep .user-profile-icon-wrapper .unliked-profile {
  display: inline-block;
  margin-top: 20px;
}

.profile-btn-wrapper {
  display: inline-block;
  margin-top: 5px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.profile-btn-wrapper a {
  font-size: 12px;
}

.work-modal {
  font-size: 14px;
  margin-top: 30px;
  padding-top: 30px;
  border-top: 1px solid #eee;
}
.work-modal h3 {
  margin-top: 0;
}
.work-modal .btn-example {
  display: inline-block;
  cursor: pointer;
}
.work-modal .work-modal_popup {
  display: none;
}
.work-modal .work-modal_popup.active {
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
}
.work-modal .work-modal_popup .popup_content {
  position: absolute;
  top: 50%;
  max-width: 600px;
  background: rgba(255, 255, 255, 0.9);
  left: 0;
  right: 0;
  font-size: 18px;
  padding: 20px;
  margin: auto;
  transform: translateY(-50%);
}
.work-modal .work-modal_popup .popup_content h3 {
  font-size: 24px;
}
.work-modal .work-modal_popup .popup_content .clx-example {
  position: absolute;
  right: -30px;
  top: -30px;
  display: inline-block;
  font-size: 24px;
  color: #fff;
  cursor: pointer;
}

.collaborate-profile {
  margin: 10px 0 15px 0;
  float: left;
  width: 100%;
}
.collaborate-profile span.left-label.profile-equation-result {
  background: #6d6e71;
  padding: 7px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 17px;
}
.collaborate-profile span.left-label.profile-equation-result a {
  color: #fff !important;
  text-decoration: none;
}
.collaborate-profile ::ng-deep .profile-equation-wrapper span {
  padding: 7px;
  color: #fff;
  font-size: 18px;
  font-weight: normal;
  display: inline-block;
}

.profile-headers h2 {
  display: inline-block;
}

.right-buttons.collaboration-profile a {
  padding: 4px 15px !important;
  font-size: 13px;
  margin: 0 !important;
  height: 26px !important;
  display: inline-block;
  vertical-align: top;
  line-height: 18px;
}
.right-buttons.collaboration-profile a.btn {
  text-decoration: none !important;
}
@media screen and (max-width: 991px) {
  .right-buttons.collaboration-profile a {
    padding-left: 0 !important;
  }
}

h2.text-capitalize.titlename.no-mg-top.profile-title {
  display: none;
}

.client-detail #cbpf6 {
  margin-top: 0;
}

.m-about .field_label,
.m-about .m-image-block,
.m-about .titlename span,
.list-unstyled .not-strong {
  font-family: "Open Sans";
}

.th-pf-links {
  margin-top: 6px;
  margin-left: 10px;
  display: inline-block;
}

.m-about .field_label.more-label {
  width: 125px;
}

@media print {
  @page {
    margin: 0;
    padding: 0;
    size: auto;
  }
  .ftpc {
    max-width: 100% !important;
  }
  .person-title {
    max-width: 200px;
  }
  .list-group li {
    width: 100% !important;
    display: flex !important;
  }
  .list-group div {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    justify-content: space-between;
  }
  .list-group li > div {
    width: 50% !important;
  }
  .collaborate-profile {
    display: flex;
    position: relative;
  }
  .collaborate-profile .right-label.right-label-text {
    position: absolute;
    right: 0;
  }
  .profile-print-btn {
    display: none !important;
  }
  .profile-btn-wrapper.pull-right a {
    display: none;
  }
  ::ng-deep html,
  body {
    height: auto !important;
  }
}
::ng-deep.collab-body .collab-data {
  padding-top: 50px !important;
}
@media screen and (max-width: 991px) {
  ::ng-deep.collab-body .collab-data {
    padding-top: 0 !important;
  }
}

::ng-deep body.fs-skin .ibox.no-border {
  border: 0 !important;
}
::ng-deep body.fs-skin .ibox-content.no-brdr {
  border: 0 !important;
}

.client-detail hr {
  width: 100%;
}

.ftpc {
  --iconsize: 90px;
  max-width: 800px;
  width: 100%;
  display: none;
}
.ftpc h2 {
  font-family: "Museo-700";
  margin-bottom: 20px;
}
.ftpc__topinner {
  display: flex;
  flex-wrap: wrap;
  margin-right: -20px;
  margin-left: -20px;
}
.ftpc__topinner > * {
  padding-right: 20px;
  padding-left: 20px;
  width: 50%;
}
.ftpc__pbox {
  border: 1px solid #e2e2e2;
}
.ftpc__pboxh {
  padding: 15px 20px;
  color: #6d6e70;
  font-weight: 800;
  text-transform: uppercase;
  font-size: 18px;
  line-height: 1.2;
  border-bottom: 1px solid #e2e2e2;
}
.ftpc__pboxh img {
  width: 20px;
  vertical-align: middle;
}
.ftpc__pboxb {
  padding: 40px 20px;
}
.ftpc__pboxbrow {
  display: flex;
  flex-wrap: wrap;
  margin-inline: -5px;
}
.ftpc__pboxbrow > * {
  padding-inline: 5px;
}
.ftpc__pboxbl {
  width: var(--iconsize);
}
.ftpc__pboxbr {
  width: calc(100% - var(--iconsize));
}
.ftpc__pboxbr h2 {
  font-family: Museo;
  font-size: 34px;
  font-family: "Museo-700";
  line-height: 1.2;
  margin-top: 0;
}
.ftpc__pboxbr h2:last-child {
  margin-bottom: 0;
}
.ftpc__subheading {
  height: 100%;
  display: flex;
  align-items: center;
}
.ftpc__subheading h3 {
  font-family: "Museo-700";
  font-size: 28px;
  margin-top: 0;
}
.ftpc__subheading h3:last-child {
  margin-bottom: 0;
}
.ftpc__bottom {
  margin-top: px;
  padding-top: 30px;
  border-top: 1px solid #e2e2e2;
}
.ftpc__bottom h2 {
  font-family: "Museo-700";
  color: #676a6c;
}
.ftpc__bottomcontent {
  column-count: 2;
  column-gap: 40px;
}
.ftpc__bottomcontent :last-child {
  margin-bottom: 0;
}

@media print {
  ::ng-deep.collab-body {
    display: none;
  }
  .ibox {
    margin-bottom: 0;
  }
  .ibox-content {
    padding-right: 0;
    padding-left: 0;
  }
  .client-detail > hr {
    display: none;
  }
  .client-detail .profile-headers {
    margin: 0 !important;
  }
  .client-detail .profile-headers__inner {
    display: none;
  }
  .ftpc {
    display: block;
  }
  .ftpc__top {
    margin-bottom: 0;
  }
  .ftpc__bottom {
    margin-top: 7px !important;
    padding-top: 5px !important;
  }
  .work-modal {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
  }
  .work-modal li {
    width: 50%;
  }
  .m-about {
    display: flex;
    flex-wrap: wrap;
    margin-top: -7px;
  }
  .m-about .list-group {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
  }
  .m-about .list-group div {
    display: flex !important;
  }
  .m-about .list-group div li {
    width: 50% !important;
    justify-content: left;
  }
  .m-about .list-group div li div:first-child {
    width: 30% !important;
  }
  .m-about .list-group div li div:last-child {
    width: 64% !important;
  }
  .m-about br {
    display: none;
  }
  .m-about .field_detail a {
    text-decoration: none;
  }
}
.email--invalid input {
  border: 1px solid #ff0000;
}

.text-info.email--invalid {
  opacity: 0.5;
}

.profile-headers__inner h2 {
  font-size: 22px;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/collaboration-profile/collaboration-profile.component.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;AA7YA;EACE,YAAA;AAgZF;AA9YE;EAHF;IAII,gBAAA;EAiZF;AACF;AA/YE;EAPF;IAQI,WAAA;EAkZF;AACF;AAhZE;EACE,kBAAA;EACA,mBAAA;AAkZJ;AAhZI;EAJF;IAKI,eAAA;EAmZJ;AACF;AAjZI;EARF;IASI,gBAAA;EAoZJ;AACF;AA/YE;EACE,WAAA;AAiZJ;AA9YE;EACE,kBAAA;AAgZJ;AA5YE;EACE,iBAAA;EACA,oBAAA;AA8YJ;AA3YE;;EAEE,mBAAA;EACA,qBAAA;EACA,2BAAA;EACA,wBAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;AA6YJ;AA3YI;EAVF;;IAWI,yBAAA;EA+YJ;AACF;AA7YI;EAdF;;IAeI,sBAAA;IACA,yBAAA;IACA,uBAAA;EAiZJ;AACF;AA9YE;EACE,WAAA;AAgZJ;AA7YE;EACE,iBAAA;AA+YJ;AA3YI;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;AA6YN;AA3YM;EAPF;IAQI,cAAA;EA8YN;AACF;AA3YI;EACE,cAAA;AA6YN;AA3YM;EAHF;IAII,UAAA;EA8YN;AACF;;AAzYA;EAEI;IACE,gBAAA;EA2YJ;AACF;AAlYA;EACE,kBAAA;AAoYF;;AAjYA;EACE,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;AAoYF;AAlYE;EANF;IAOI,gBAAA;EAqYF;AACF;AAnYE;EACE,eAAA;EACA,WAAA;EACA,qBAAA;EACA,mBAAA;AAqYJ;AAlYE;EACE,YAAA;AAoYJ;;AA9XA;EACE,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,WAAA;EACA,iBAAA;AAiYF;AA/XE;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,8BAAA;EACA,WD5Ee;EC6Ef,cAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AAiYJ;AA9XE;EACE,UAAA;EACA,wBAAA;EACA,eAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;AAgYJ;;AA1XA;EACE,0BAAA;AA6XF;;AA1XA;EACE,kBAAA;EACA,WAAA;EACA,aAAA;AA6XF;AA3XE;EACE,gBAAA;EACA,qBAAA;AA6XJ;AA3XI;EACE,8BAAA;AA6XN;;AAxXA;EACE,WAAA;AA2XF;;AAvXA;EACE,SAAA;AA0XF;;AAvXA;EACE,eAAA;EACA,wEAAA;AA0XF;;AAvXA;;;EAGE,WAAA;EACA,qBAAA;AA0XF;;AAvXA;EACE,kBAAA;EACA,WAAA;AA0XF;;AAvXA;EACE,kBAAA;EAEA,YAAA;EAEA,gBAAA;EACA,iBAAA;EACA,0BAAA;AAwXF;AAtXE;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,qCAAA;AAwXJ;AApXM;;EAEE,aAAA;AAsXR;AAlXI;EACE,wEAAA;AAoXN;AAlXM;EACE,WDnLW;ECoLX,YAAA;AAoXR;AAjXM;EACE,cDvNa;AC0kBrB;AA/WI;EACE,mBD5Ne;EC6Nf,YAAA;EACA,wEAAA;AAiXN;AA/WM;EACE,WDlMW;ECmMX,qBAAA;AAiXR;AA5WE;EACE,WAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EAEA,mBAAA;EAEA,eAAA;EAEA,kBAAA;EAEA,cAAA;AA8WJ;AA5WI;EACE,gBAAA;AA8WN;;AAvWE;EACE,6CAAA;AA0WJ;AAvWE;EACE,6CAAA;AAyWJ;AAtWE;EACE,6CAAA;AAwWJ;;AAnWA;EACE,iBAAA;EACA,iBAAA;AAsWF;AApWE;EACE,qBAAA;EACA,gBAAA;AAsWJ;;AAlWA;EACE,qBAAA;EACA,eAAA;EACA,wEAAA;AAqWF;AAnWE;EACE,eAAA;AAqWJ;;AA9UA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,0BAAA;AAiVF;AA/UE;EACE,aAAA;AAiVJ;AA9UE;EACE,qBAAA;EACA,eAAA;AAgVJ;AA7UE;EACE,aAAA;AA+UJ;AA7UI;EACE,cAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,aAAA;AA+UN;AA5UI;EACE,kBAAA;EACA,QAAA;EACA,gBAAA;EACA,oCAAA;EACA,OAAA;EACA,QAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;EAGA,2BAAA;AA8UN;AA5UM;EACE,eAAA;AA8UR;AA3UM;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,qBAAA;EACA,eAAA;EACA,WDxUW;ECyUX,eAAA;AA6UR;;AAvUA;EACE,qBAAA;EACA,WAAA;EACA,WAAA;AA0UF;AAxUE;EACE,mBDpXiB;ECqXjB,YAAA;EACA,wEAAA;EACA,eAAA;AA0UJ;AAxUI;EACE,sBAAA;EACA,qBAAA;AA0UN;AArUI;EACE,YAAA;EACA,WDnWa;ECoWb,eAAA;EACA,mBAAA;EACA,qBAAA;AAuUN;;AAlUA;EACE,qBAAA;AAqUF;;AAjUE;EACE,4BAAA;EACA,eAAA;EACA,oBAAA;EACA,uBAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;AAoUJ;AAlUI;EACE,gCAAA;AAoUN;AAjUI;EAbF;IAcI,0BAAA;EAoUJ;AACF;;AA/TA;EACE,aAAA;AAkUF;;AA+JA;EACE,aAAA;AA5JF;;AA+JA;;;;EAIE,wBAAA;AA5JF;;AA+JA;EACE,eAAA;EACA,iBAAA;EACA,qBAAA;AA5JF;;AA+JA;EACE,YAAA;AA5JF;;AA+JA;EAEE;IACE,SAAA;IACA,UAAA;IACA,UAAA;EA7JF;EAgKA;IACE,0BAAA;EA9JF;EAqKA;IACE,gBAAA;EAnKF;EAsKA;IACE,sBAAA;IACA,wBAAA;EApKF;EAuKA;IACE,aAAA;IACA,eAAA;IACA,WAAA;IACA,8BAAA;EArKF;EAwKA;IACE,qBAAA;EAtKF;EAyKA;IACE,aAAA;IACA,kBAAA;EAvKF;EA0KI;IACE,kBAAA;IACA,QAAA;EAxKN;EAgLA;IACE,wBAAA;EA9KF;EAqLI;IACE,aAAA;EAnLN;EAwLA;;IAEE,uBAAA;EAtLF;AACF;AA6LE;EACE,4BAAA;AA3LJ;AA6LI;EAHF;IAII,yBAAA;EA1LJ;AACF;;AAkMI;EACE,oBAAA;AA/LN;AAqMI;EACE,oBAAA;AAnMN;;AA2ME;EACE,WAAA;AAxMJ;;AA4MA;EACE,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,aAAA;AAzMF;AA2ME;EACE,wBDjjCO;ECkjCP,mBAAA;AAzMJ;AA4ME;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;AA1MJ;AA4MI;EACE,mBAAA;EACA,kBAAA;EACA,UAAA;AA1MN;AA8ME;EACE,yBAAA;AA5MJ;AA+ME;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;AA7MJ;AA+MI;EACE,WAAA;EACA,sBAAA;AA7MN;AAiNE;EACE,kBAAA;AA/MJ;AAkNE;EACE,aAAA;EACA,eAAA;EACA,mBAAA;AAhNJ;AAkNI;EACE,mBAAA;AAhNN;AAoNE;EACE,sBAAA;AAlNJ;AAqNE;EACE,mCAAA;AAnNJ;AAqNI;EACE,kBAAA;EACA,eAAA;EACA,wBD7mCK;EC8mCL,gBAAA;EACA,aAAA;AAnNN;AAqNM;EACE,gBAAA;AAnNR;AAwNE;EACE,YAAA;EACA,aAAA;EACA,mBAAA;AAtNJ;AAwNI;EACE,wBD7nCK;EC8nCL,eAAA;EACA,aAAA;AAtNN;AAwNM;EACE,gBAAA;AAtNR;AA4NE;EACE,cAAA;EACA,iBAAA;EACA,6BAAA;AA1NJ;AA4NI;EACE,wBD9oCK;EC+oCL,cAAA;AA1NN;AA8NE;EACE,eAAA;EACA,gBAAA;AA5NJ;AA8NI;EACE,gBAAA;AA5NN;;AAmOA;EACE;IACE,aAAA;EAhOF;EAmOA;IACE,gBAAA;EAjOF;EAoOA;IACE,gBAAA;IACA,eAAA;EAlOF;EAuOE;IACE,aAAA;EArOJ;EAwOE;IACE,oBAAA;EAtOJ;EAwOI;IACE,aAAA;EAtON;EA4OA;IACE,cAAA;EA1OF;EA4OE;IACE,gBAAA;EA1OJ;EA6OE;IACE,0BAAA;IACA,2BAAA;EA3OJ;EA+OA;IACE,aAAA;IACA,eAAA;IACA,WAAA;EA7OF;EA+OE;IACE,UAAA;EA7OJ;EAkPA;IACE,aAAA;IACA,eAAA;IACA,gBAAA;EAhPF;EAkPE;IACE,aAAA;IACA,eAAA;IACA,WAAA;EAhPJ;EAkPI;IACE,wBAAA;EAhPN;EAkPM;IACE,qBAAA;IACA,qBAAA;EAhPR;EAkPQ;IACE,qBAAA;EAhPV;EAmPQ;IACE,qBAAA;EAjPV;EAuPE;IACE,aAAA;EArPJ;EA0PI;IACE,qBAAA;EAxPN;AACF;AAgQE;EACE,yBAAA;AA9PJ;;AAkQA;EACE,YAAA;AA/PF;;AAsQI;EACE,eAAA;AAnQN","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","@import './../../../assets/styles/variables';\n\n.m-about {\n  padding: 0px;\n\n  @media screen and (max-width: 1200px) {\n    margin-top: 20px;\n  }\n\n  @media screen and (max-width:1000px) {\n    width: 100%;\n  }\n\n  &.m-image-block {\n    padding-left: 15px;\n    padding-right: 15px;\n\n    @media screen and (max-width: 1200px) {\n      margin-top: 0px;\n    }\n\n    @media screen and (max-width: 850px) {\n      margin-top: 20px;\n    }\n\n\n  }\n\n  .about-condition {\n    width: 100%;\n  }\n\n  .no-pad-right {\n    padding-right: 0px;\n  }\n\n\n  h2 {\n    font-weight: bold;\n    margin: 20px 0 5px 0;\n  }\n\n  .field_label,\n  .field_detail {\n    display: table-cell;\n    word-wrap: break-word;\n    -webkit-table-layout: fixed;\n    -moz-table-layout: fixed;\n    -ms-table-layout: fixed;\n    -o-table-layout: fixed;\n    table-layout: fixed;\n\n    @media screen and (min-width:769px) and (max-width:1199px) {\n      display: block !important;\n    }\n\n    @media screen and (max-width: 599px) {\n      width: 100% !important;\n      display: block !important;\n      padding: 0px !important;\n    }\n  }\n\n  .field_label {\n    width: 85px;\n  }\n\n  .field_detail {\n    padding-left: 2px;\n  }\n\n  .list-group {\n    .list-group-item {\n      display: table;\n      width: 100%;\n      border: none;\n      padding: 3px 0px;\n      font-size: 16px;\n\n      @media screen and (max-width: 599px) {\n        display: block;\n      }\n    }\n\n    .list-group-item.col-sm-6 {\n      display: block;\n\n      @media(min-width:768px) {\n        width: 50%;\n      }\n    }\n  }\n}\n\n@media screen and (max-width: 991px) {\n  .m-about {\n    .no-pad-left {\n      padding-right: 0;\n    }\n  }\n}\n\n\n\n\n// Image-Upload-Style on Profile\n\n.edit-image-wrapper {\n  position: relative;\n}\n\n.person-title {\n  max-width: 300px;\n  width: 100%;\n  margin-right: 15px;\n  margin-bottom: 15px;\n\n  @media screen and (max-width: 1200px) {\n    max-width: 240px;\n  }\n\n  .img-responsive {\n    max-width: 100%;\n    width: 100%;\n    display: inline-block;\n    background: #f2f2f2;\n  }\n\n  .m-b-sm {\n    padding: 5px;\n  }\n\n}\n\n\n.upload_button_holder {\n  position: absolute;\n  overflow: hidden;\n  display: inline-block;\n  width: 100%;\n  margin-top: -33px;\n\n  .upload_button {\n    position: relative;\n    font-weight: 700;\n    font-size: 14px;\n    line-height: 21px;\n    background: rgba(0, 0, 0, .4);\n    color: $color-light-type;\n    padding: 5px 0;\n    border-radius: 0;\n    width: 100%;\n    height: 32px;\n    text-decoration: none;\n    text-align: center;\n    cursor: pointer;\n    display: block;\n  }\n\n  .cloudinary_fileupload {\n    opacity: 0;\n    filter: alpha(opacity=0);\n    cursor: pointer;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    margin: 0;\n    padding: 0;\n    border: none;\n  }\n}\n\n// User-Profile-About-text\n\n.titlename.no-mg-top {\n  margin-top: 2px !important;\n}\n\n.right-buttons {\n  position: absolute;\n  right: 10px;\n  z-index: 9999;\n\n  &--change1 {\n    position: static;\n    display: inline-block;\n\n    .profile-print-btn {\n      padding-right: 10px !important;\n    }\n  }\n}\n\n.user-profile-wrapper a {\n  color: #333;\n  // text-decoration: underline;\n}\n\n.no-margin {\n  margin: 0;\n}\n\n.m-about p {\n  font-size: 14px;\n  font-family: \"Open Sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n}\n\n.user-profile-wrapper a:hover,\n.user-profile-wrapper a:focus,\n.user-profile-wrapper a:active {\n  color: #333;\n  text-decoration: none;\n}\n\n.profile-heading {\n  margin-left: -20px;\n  width: 105%;\n}\n\n.client-detail {\n  position: relative;\n  // min-height: 620px;\n  height: auto;\n\n  margin-top: 30px;\n  padding-top: 30px;\n  border-top: 1px solid #eee;\n\n  .profile-headers {\n    clear: both;\n    float: left;\n    width: 100%;\n    margin: 30px 0;\n    font-size: 18px;\n    line-height: 1.4;\n    font-family: \"Conv_museo-500-webfont\";\n\n    &__inner {\n\n      h2,\n      span {\n        margin-top: 0;\n      }\n    }\n\n    .profile-equation-wrapper {\n      font-family: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n\n      span {\n        color: $color-light-type;\n        padding: 7px;\n      }\n\n      .eq-plus {\n        color: $color-neutral-dark;\n      }\n    }\n\n    .profile-equation-result {\n      background: $color-neutral-dark;\n      padding: 7px;\n      font-family: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n\n      a {\n        color: $color-light-type;\n        text-decoration: none;\n      }\n    }\n  }\n\n  .client_description {\n    clear: both;\n    text-align: justify;\n    font-size: 16px;\n    margin-bottom: 30px;\n    -webkit-column-count: 2;\n    -ms-column-count: 2;\n    -moz-column-count: 2;\n    column-count: 2;\n    -webkit-column-gap: 20;\n    -ms-column-gap: 20;\n    -moz-column-gap: 20;\n    column-gap: 20;\n\n    span.profile-desc {\n      font-weight: 700;\n    }\n  }\n}\n\n.right-label-text {\n\n  .eq-implementer {\n    background-color: $implement-color !important;\n  }\n\n  .eq-clarifier {\n    background-color: $clarify-color !important;\n  }\n\n  .eq-ideator {\n    background-color: $ideate-color !important;\n  }\n}\n\n\n::ng-deep .user-profile-icon-wrapper {\n  margin-top: -12px;\n  margin-left: 19px;\n\n  .unliked-profile {\n    display: inline-block;\n    margin-top: 20px;\n  }\n}\n\n.profile-btn-wrapper {\n  display: inline-block;\n  margin-top: 5px;\n  font-family: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n\n  a {\n    font-size: 12px;\n  }\n}\n\n\n\n\n// .disabled.timezone-selector {\n//     outline: none;\n//     border: none;\n//     background: 0 0;\n//     -webkit-appearance: none;\n//     -moz-appearance: none;\n//     text-indent: 1px;\n//     text-overflow: '';\n//     padding-top: 2px;\n//     padding-left: 0;\n// }\n\n\n\n\n\n.work-modal {\n  font-size: 14px;\n  margin-top: 30px;\n  padding-top: 30px;\n  border-top: 1px solid #eee;\n\n  h3 {\n    margin-top: 0;\n  }\n\n  .btn-example {\n    display: inline-block;\n    cursor: pointer;\n  }\n\n  .work-modal_popup {\n    display: none;\n\n    &.active {\n      display: block;\n      position: fixed;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      background: rgba(0, 0, 0, .5);\n      z-index: 9999;\n    }\n\n    .popup_content {\n      position: absolute;\n      top: 50%;\n      max-width: 600px;\n      background: rgba(255, 255, 255, .9);\n      left: 0;\n      right: 0;\n      font-size: 18px;\n      padding: 20px;\n      margin: auto;\n      -webkit-transform: translateY(-50%);\n      -ms-transform: translateY(-50%);\n      transform: translateY(-50%);\n\n      h3 {\n        font-size: 24px;\n      }\n\n      .clx-example {\n        position: absolute;\n        right: -30px;\n        top: -30px;\n        display: inline-block;\n        font-size: 24px;\n        color: $color-light-type;\n        cursor: pointer;\n      }\n    }\n  }\n}\n\n.collaborate-profile {\n  margin: 10px 0 15px 0;\n  float: left;\n  width: 100%;\n\n  span.left-label.profile-equation-result {\n    background: $color-neutral-dark;\n    padding: 7px;\n    font-family: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n    font-size: 17px;\n\n    a {\n      color: $color-light-type !important;\n      text-decoration: none;\n    }\n  }\n\n  ::ng-deep .profile-equation-wrapper {\n    span {\n      padding: 7px;\n      color: $color-light-type;\n      font-size: 18px;\n      font-weight: normal;\n      display: inline-block;\n    }\n  }\n}\n\n.profile-headers h2 {\n  display: inline-block;\n}\n\n.right-buttons.collaboration-profile {\n  a {\n    padding: 4px 15px !important;\n    font-size: 13px;\n    margin: 0 !important;\n    height: 26px !important;\n    display: inline-block;\n    vertical-align: top;\n    line-height: 18px;\n\n    &.btn {\n      text-decoration: none !important;\n    }\n\n    @media screen and (max-width: 991px) {\n      padding-left: 0 !important;\n    }\n  }\n}\n\n\nh2.text-capitalize.titlename.no-mg-top.profile-title {\n  display: none;\n}\n\n// @media print {\n\n//   html,\n//   body {\n//     width: 100% !important;\n//     height: 100% !important;\n//   }\n\n//   .person-title {\n//     display: none !important;\n//   }\n\n//   #page-wrapper {\n//     -before: always;\n//   }\n\n//   .all-toolcards .innovation-section.toolcards p {\n//     margin-bottom: 30px;\n//   }\n\n//   .all-toolcards .toolcards.innovation-section+.innovation-section {\n//     page-break-before: always;\n//   }\n\n//   .client-detail {\n//     display: none !important;\n//   }\n\n//   .col-sm-12.col-md-4.person-title {\n//     display: none;\n//   }\n\n//   .right-buttons.collaboration-profile {\n//     display: none;\n//   }\n\n//   .collaborate-profile {\n//     display: inline-block;\n//     width: 100% !important;\n//     float: none !important;\n//     vertical-align: middle;\n//     clear: none;\n//   }\n\n//   .user-profile-wrapper .user-profile-icon-wrapper {\n//     margin-left: 0;\n//   }\n\n//   h2.text-capitalize.titlename.no-mg-top {\n//     display: inline-block;\n//     margin-right: 15px;\n//     width: 120px;\n//     vertical-align: middle;\n//     display: none;\n//   }\n\n//   span.left-label.profile-equation-result.pull-left {\n//     display: inline-block;\n//     margin-right: 15px;\n//     //width: 120px;\n//     vertical-align: middle;\n//     background: $color-neutral-dark !important;\n//   }\n\n//   span.left-label.profile-equation-result.pull-left a {\n//     background: $color-neutral-dark !important;\n//     color: $color-light-type !important;\n\n//   }\n\n//   .print-block.hidden {\n//     display: block !important;\n//   }\n\n//   .wrapper.wrapper-content.animated.fadeInRight {\n//     page-break-after: avoid;\n//     transform: rotate(180deg) !important;\n//     animation: none;\n//   }\n\n//   .wrapper.wrapper-content.animated.fadeInRight .ibox-content {\n//     padding-top: 0;\n//     padding-bottom: 0;\n//     border: none;\n//   }\n\n//   .print-folded-block-first,\n//   .print-unfold-block-second {\n//     transform: rotate(180deg) !important;\n//   }\n\n//   .print-unfold-block-first,\n//   .print-unfold-block-second,\n//   .print-folded-block-first,\n//   .wrapper.wrapper-content.animated.fadeInRight {\n//     width: 100%;\n//     clear: both;\n//     float: left;\n//     min-height: 200px;\n//     background-color: #f6f6f6;\n\n//     border-bottom: 1px dashed #ddd;\n//     page-break-after: avoid;\n//     position: relative;\n//   }\n\n//   .print-block.print-folded-block-first {\n//     padding-top: 40px;\n//     min-height: 100%;\n//     height: 300px;\n//     border-top: 1px dashed #ddd;\n//   }\n\n//   .print-block.print-unfold-block-first {\n//     min-height: 100%;\n//     display: -webkit-box !important;\n//     display: -ms-flexbox !important;\n//     display: flex !important;\n//     -webkit-box-align: center;\n//     -ms-flex-align: center;\n//     align-items: center;\n//     height: 300px;\n//     padding-top: 0px !important;\n//     padding-bottom: 60px !important;\n//   }\n\n//   .print-block.print-unfold-block-first .main-block {\n//     float: left;\n//     width: 100%;\n//     margin-top: -20px;\n//   }\n\n//   .print-folded-block-first .profile-btn-wrapper {\n//     position: absolute;\n//     left: 0;\n//     right: 0;\n//     margin: 0 auto;\n//     width: 100%;\n//     height: 100%;\n//   }\n\n//   .print-folded-block-first .profile-btn-wrapper .block-print {\n//     width: calc(100% / 2 - 10px);\n//     height: 100%;\n//     line-height: 282px;\n//     display: inline-block;\n//   }\n\n//   .print-folded-block-first .profile-btn-wrapper .block-print a {\n//     line-height: normal;\n//     text-align: center;\n//     padding: 20px;\n//     display: inline-block;\n//     font-size: 22px;\n//     vertical-align: middle;\n//     width: 100%;\n//   }\n\n//   .print-unfold-block-first .top-headTitle,\n//   .profile-btn-wrapper.print-btn-wrapper {\n//     float: left;\n//     width: 100%;\n//     clear: both;\n//     padding: 20px;\n//     text-align: center;\n//   }\n\n//   .print-unfold-block-first {\n//     padding-top: 25px;\n//   }\n\n//   .top-headTitle .ng-isolate-scope {\n//     display: inline-block;\n//     vertical-align: middle;\n//     width: 100%;\n//   }\n\n//   .top-headTitle span {\n//     font-size: 25px;\n//     font-weight: bold;\n//   }\n\n//   .left-prf,\n//   .right-prf {\n//     display: inline-block;\n//     vertical-align: middle;\n//   }\n\n//   .rgt-profile {\n//     display: block !important;\n//     float: none !important;\n//     margin-right: 0 !important;\n//     margin-top: 17px;\n//   }\n\n//   .rgt-profile a {\n//     padding: 8px;\n//   }\n\n//   .profile-btn-wrapper.print-btn-wrapper a {\n//     margin-right: 25px;\n//   }\n\n//   .profile-btn-wrapper.print-btn-wrapper a+a {\n//     margin-right: 0px;\n//   }\n\n//   .print-unfold-block-second {\n//     padding-top: 20px;\n//   }\n\n//   .print-unfold-block-second .print-twoCol,\n//   .print-unfold-block-second .block-footer {\n//     float: left;\n//     width: 100%;\n//     clear: both;\n//   }\n\n//   .print-twoCol {\n//     display: table;\n//     width: 100%;\n//     padding-left: 25px;\n//     padding-right: 25px;\n//   }\n\n//   .leftBlock,\n//   .rightBlock {\n//     width: 50%;\n//     padding: 20px;\n//     display: table-cell;\n//     vertical-align: middle;\n//     border: 1px solid #ddd;\n//   }\n\n//   .leftBlock {\n//     border-right: none;\n//   }\n\n//   .block-footer {\n//     display: table;\n//     text-align: center;\n//     float: left;\n//     width: 100%;\n//     margin-top: 20px;\n//   }\n\n//   .print-unfold-block-second,\n//   .wrapper.wrapper-content.animated.fadeInRight {\n//     border: none;\n//   }\n\n//   .wrapper.wrapper-content.animated.fadeInRight {\n//     padding-bottom: 0 !important;\n//   }\n\n//   .wrapper.wrapper-content.animated.fadeInRight .tab-content .pos-relative {\n//     margin: 0;\n//   }\n\n//   .print-folded-block-first span.eq-clarifier {\n//     background-color: $clarify-color !important;\n//   }\n\n//   .print-folded-block-first .eq-ideator {\n//     background-color: $ideate-color !important;\n//   }\n\n//   .print-folded-block-first .eq-implementer {\n//     background-color: $implement-color !important;\n//   }\n\n//   .print-folded-block-first .eq-developer {\n//     background-color: $develop-color !important;\n//   }\n\n//   .print-title-heading {\n//     max-width: 100%;\n//     text-align: center;\n//     margin: auto;\n//     width: 100%;\n//   }\n\n//   .print-first-name {\n//     font-size: 50px !important;\n//     line-height: 1 !important;\n//   }\n\n//   span.top-headlast-name {\n//     font-size: 25px !important;\n//     text-align: right;\n//     line-height: 1 !important;\n//     display: block;\n//   }\n\n//   span.print-profile {\n//     display: inline-block !important;\n//     vertical-align: top;\n//     margin-right: 30px;\n//   }\n\n\n//   /***************\n//       profiles\n//   ****************/\n//   .profile-btn-wrapper {\n//     margin-top: 38px !important;\n//   }\n\n//   .pref {\n//     margin-top: 15px;\n//     color: $color-light-type !important;\n//   }\n\n//   /****New style for center section****/\n//   .pref.clarify span {\n//     background: $clarify-color !important;\n//     color: $color-light-type !important;\n//   }\n\n//   .pref.ideate h4 span {\n//     background: $ideate-color !important;\n//     color: $color-light-type !important;\n//   }\n\n//   .pref.developer h4 span {\n//     background: $develop-color !important;\n//     color: $color-light-type !important;\n//   }\n\n//   .pref.implement h4 span {\n//     background: $implement-color !important;\n//     color: $color-light-type !important;\n//   }\n\n//   .col-print-section {\n//     font-family: 'Helvetica Neue';\n//   }\n\n//   .col-print-section ul {\n//     padding: 0;\n//     margin: 0;\n\n//   }\n\n//   .col-print-section h4 {\n//     font-size: 15px;\n//     color: $color-light-type !important;\n//   }\n\n//   .col-print-section h4 span {\n//     color: $color-light-type !important;\n//     padding: 5px;\n//   }\n\n//   .col-print-section ul li {\n//     list-style: none;\n//     font-size: 15px;\n//     // font-family: Museo-300;\n//   }\n\n//   .col-print-section .pref.clarify ul li,\n//   .col-print-section .pref.clarify ul li::before {\n//     color: $clarify-color !important;\n//   }\n\n//   .col-print-section .pref.ideate ul li,\n//   .col-print-section .pref.ideate ul li::before {\n//     color: $ideate-color !important;\n//   }\n\n//   .col-print-section .pref.developer ul li,\n//   .col-print-section .pref.developer ul li::before {\n//     color: $develop-color !important;\n//   }\n\n//   .col-print-section .pref.implement ul li,\n//   .col-print-section .pref.implement ul li::before {\n//     color: $implement-color !important;\n//   }\n\n//   .col-print-section ul li:before {\n//     content: \"\\2022\";\n//     margin-right: 5px;\n//   }\n\n//   h2.text-capitalize.titlename.no-mg-top.profile-title {\n//     display: none;\n//   }\n\n\n//   /****** Normal Print *********/\n//   ::ng-deep body.fs-skin.profile-print-body {\n//     .print-block.hidden {\n//       display: none !important;\n//     }\n\n//     .person-title {\n//       display: block !important;\n//     }\n\n//     .m-image-block {\n//       padding-right: 0px;\n//       padding-left: 0px;\n//     }\n\n//     h2.text-capitalize.titlename.no-mg-top.profile-title {\n//       display: inline-block !important;\n//       float: left;\n//       width: auto;\n//     }\n\n//     span.left-label.profile-equation-result.pull-left {\n//       margin-bottom: 15px;\n//     }\n\n//     span.profile-btn-wrapper.pull-right {\n//       display: none;\n//     }\n\n//     span.right-label.right-label-text.profile-equation-wrapper.pull-right.ng-binding {\n//       float: left !important;\n//       clear: both;\n//     }\n\n//     .client-detail {\n//       display: block !important;\n//       /*page-break-before: always;*/\n//     }\n\n//     .wrapper.wrapper-content.animated.fadeInRight {\n//       -webkit-transform: rotate(0) !important;\n//       transform: rotate(0) !important;\n//     }\n\n//     .col-sm-12.col-md-4.person-title {\n//       display: block !important;\n//       width: 33.33333333%;\n//       float: left;\n//     }\n\n//     .col-sm-12.col-md-8.m-about {\n//       width: 66.66666667%;\n//       float: left;\n//     }\n\n//     .work-modal li {\n//       width: 50%;\n//       float: left;\n//     }\n//   }\n\n// }\n\n// @media print {\n//   ::ng-deep .printProfileType .profile_types {\n//     transform: scale(2.2) !important;\n//     -webkit-transform: scale(2.2) !important;\n//     -moz-transform: scale(2.2) !important;\n//     -ms-transform: scale(2.2) !important;\n//     margin-left: 33px !important;\n//     width: 33px !important;\n//     margin-top: 25px !important;\n//   }\n\n//   // ::ng-deep html {\n//   //   position: absolute;\n//   //   left: -5%;\n//   //   right: 0;\n//   //   margin: 0 auto;\n//   //   top: 50%;\n//   //   transform: translateY(-50%);\n//   //   zoom: 0.7555;\n//   // }\n\n\n// }\n\n\n.client-detail #cbpf6 {\n  margin-top: 0;\n}\n\n.m-about .field_label,\n.m-about .m-image-block,\n.m-about .titlename span,\n.list-unstyled .not-strong {\n  font-family: 'Open Sans';\n}\n\n.th-pf-links {\n  margin-top: 6px;\n  margin-left: 10px;\n  display: inline-block;\n}\n\n.m-about .field_label.more-label {\n  width: 125px;\n}\n\n@media print {\n\n  @page {\n    margin: 0;\n    padding: 0;\n    size: auto;\n  }\n\n  .ftpc {\n    max-width: 100% !important;\n  }\n\n  // .col-md-12 {\n  //   margin-top: 30px !important;\n  // }\n\n  .person-title {\n    max-width: 200px;\n  }\n\n  .list-group li {\n    width: 100% !important;\n    display: flex !important;\n  }\n\n  .list-group div {\n    display: flex;\n    flex-wrap: wrap;\n    width: 100%;\n    justify-content: space-between;\n  }\n\n  .list-group li>div {\n    width: 50% !important;\n  }\n\n  .collaborate-profile {\n    display: flex;\n    position: relative;\n\n    .right-label {\n      &.right-label-text {\n        position: absolute;\n        right: 0;\n\n      }\n\n    }\n  }\n\n\n  .profile-print-btn {\n    display: none !important;\n  }\n\n  .profile-btn-wrapper {\n\n    &.pull-right {\n\n      a {\n        display: none;\n      }\n    }\n  }\n\n  ::ng-deep html,\n  body {\n    height: auto !important;\n  }\n\n\n}\n\n::ng-deep.collab-body {\n\n  .collab-data {\n    padding-top: 50px !important;\n\n    @media screen and (max-width: 991px) {\n      padding-top: 0 !important;\n    }\n  }\n}\n\n::ng-deep body.fs-skin {\n\n  .ibox {\n\n    &.no-border {\n      border: 0 !important;\n    }\n  }\n\n  .ibox-content {\n\n    &.no-brdr {\n      border: 0 !important;\n    }\n  }\n\n}\n\n.client-detail {\n\n  hr {\n    width: 100%;\n  }\n}\n\n.ftpc {\n  --iconsize: 90px;\n  max-width: 800px;\n  width: 100%;\n  display: none;\n\n  h2 {\n    font-family: $muso-700;\n    margin-bottom: 20px;\n  }\n\n  &__topinner {\n    display: flex;\n    flex-wrap: wrap;\n    margin-right: -20px;\n    margin-left: -20px;\n\n    &>* {\n      padding-right: 20px;\n      padding-left: 20px;\n      width: 50%;\n    }\n  }\n\n  &__pbox {\n    border: 1px solid #e2e2e2;\n  }\n\n  &__pboxh {\n    padding: 15px 20px;\n    color: #6d6e70;\n    font-weight: 800;\n    text-transform: uppercase;\n    font-size: 18px;\n    line-height: 1.2;\n    border-bottom: 1px solid #e2e2e2;\n\n    img {\n      width: 20px;\n      vertical-align: middle;\n    }\n  }\n\n  &__pboxb {\n    padding: 40px 20px;\n  }\n\n  &__pboxbrow {\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: -5px;\n\n    &>* {\n      padding-inline: 5px;\n    }\n  }\n\n  &__pboxbl {\n    width: var(--iconsize);\n  }\n\n  &__pboxbr {\n    width: calc(100% - var(--iconsize));\n\n    h2 {\n      font-family: Museo;\n      font-size: 34px;\n      font-family: $muso-700;\n      line-height: 1.2;\n      margin-top: 0;\n\n      &:last-child {\n        margin-bottom: 0;\n      }\n    }\n  }\n\n  &__subheading {\n    height: 100%;\n    display: flex;\n    align-items: center;\n\n    h3 {\n      font-family: $muso-700;\n      font-size: 28px;\n      margin-top: 0;\n\n      &:last-child {\n        margin-bottom: 0;\n      }\n    }\n\n  }\n\n  &__bottom {\n    margin-top: px;\n    padding-top: 30px;\n    border-top: 1px solid #e2e2e2;\n\n    h2 {\n      font-family: $muso-700;\n      color: #676a6c;\n    }\n  }\n\n  &__bottomcontent {\n    column-count: 2;\n    column-gap: 40px;\n\n    :last-child {\n      margin-bottom: 0;\n    }\n  }\n\n}\n\n\n@media print {\n  ::ng-deep.collab-body {\n    display: none;\n  }\n\n  .ibox {\n    margin-bottom: 0;\n  }\n\n  .ibox-content {\n    padding-right: 0;\n    padding-left: 0;\n  }\n\n  .client-detail {\n\n    &>hr {\n      display: none;\n    }\n\n    .profile-headers {\n      margin: 0 !important;\n\n      &__inner {\n        display: none;\n      }\n    }\n\n  }\n\n  .ftpc {\n    display: block;\n\n    &__top {\n      margin-bottom: 0;\n    }\n\n    &__bottom {\n      margin-top: 7px !important;\n      padding-top: 5px !important;\n    }\n  }\n\n  .work-modal {\n    display: flex;\n    flex-wrap: wrap;\n    width: 100%;\n\n    li {\n      width: 50%;\n    }\n\n  }\n\n  .m-about {\n    display: flex;\n    flex-wrap: wrap;\n    margin-top: -7px;\n\n    .list-group {\n      display: flex;\n      flex-wrap: wrap;\n      width: 100%;\n\n      div {\n        display: flex !important;\n\n        li {\n          width: 50% !important;\n          justify-content: left;\n\n          div:first-child {\n            width: 30% !important;\n          }\n\n          div:last-child {\n            width: 64% !important;\n          }\n        }\n      }\n    }\n\n    br {\n      display: none;\n    }\n\n    .field_detail {\n\n      a {\n        text-decoration: none;\n      }\n    }\n  }\n\n}\n\n.email--invalid {\n\n  input {\n    border: 1px solid #ff0000;\n  }\n}\n\n.text-info.email--invalid {\n  opacity: 0.5;\n}\n\n.profile-headers {\n\n  &__inner {\n\n    h2 {\n      font-size: 22px;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
